module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    staticClass: "modal-lg",
    attrs: {
      "modal-title": 'Edit Campaign'
    },
    on: {
      "close": function($event) {
        return _vm.close()
      },
      "save": function($event) {
        return _vm.save()
      }
    }
  }, [_c('FormulateForm', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', [_vm._v("Details")]), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "text",
      "name": "name",
      "label": "Name",
      "validation": "required"
    },
    model: {
      value: (_vm.campaignModel.name),
      callback: function($$v) {
        _vm.$set(_vm.campaignModel, "name", $$v)
      },
      expression: "campaignModel.name"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "select",
      "options": _vm.providers,
      "name": "provider",
      "label": "Provider",
      "validation": "required"
    },
    model: {
      value: (_vm.campaignModel.provider),
      callback: function($$v) {
        _vm.$set(_vm.campaignModel, "provider", $$v)
      },
      expression: "campaignModel.provider"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "options": {
        regular: 'Data Lead',
        transfer: 'Call Transfer',
        appointment: 'Appointment Lead',
        'bookable-appointment': 'Bookable Appointment',
        'ping-post': 'Ping-POST',
        facebook: 'Facebook',
        google: 'Google',
        hubspot: 'Hubspot',
      },
      "type": "select",
      "label": "Type"
    },
    on: {
      "change": function($event) {
        return _vm.bidCheck()
      }
    },
    model: {
      value: (_vm.campaignModel.campaign_type),
      callback: function($$v) {
        _vm.$set(_vm.campaignModel, "campaign_type", $$v)
      },
      expression: "campaignModel.campaign_type"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', [_vm._v("Status")]), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "group"
    }
  }, [_c('FormulateInput', {
    attrs: {
      "type": "checkbox",
      "name": "is_active",
      "label": "Active"
    },
    model: {
      value: (_vm.campaignModel.current_status.is_active),
      callback: function($$v) {
        _vm.$set(_vm.campaignModel.current_status, "is_active", $$v)
      },
      expression: "campaignModel.current_status.is_active"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "checkbox",
      "name": "is_test",
      "label": "Test"
    },
    model: {
      value: (_vm.campaignModel.current_status.is_test),
      callback: function($$v) {
        _vm.$set(_vm.campaignModel.current_status, "is_test", $$v)
      },
      expression: "campaignModel.current_status.is_test"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "checkbox",
      "name": "return_grades",
      "label": "Return Grades"
    },
    model: {
      value: (_vm.campaignModel.return_grades),
      callback: function($$v) {
        _vm.$set(_vm.campaignModel, "return_grades", $$v)
      },
      expression: "campaignModel.return_grades"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "select",
      "options": _vm.tagRuleOptions,
      "name": "agent_zone_rule",
      "label": "Rule for Agent Zone Matching"
    },
    model: {
      value: (_vm.campaignModel.agent_zone_rule),
      callback: function($$v) {
        _vm.$set(_vm.campaignModel, "agent_zone_rule", $$v)
      },
      expression: "campaignModel.agent_zone_rule"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.campaignModel.campaign_type === 'ping-post') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.campaignModel.bid),
      expression: "campaignModel.bid",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.campaignModel.bid)
    },
    on: {
      "change": function($event) {
        return _vm.valCheck()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaignModel, "bid", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "number"
    }
  }, [_vm._v("Bid")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Tags")]), _vm._v(" "), _c('tags-widget', {
    attrs: {
      "tags": _vm.campaignModel.tags
    },
    on: {
      "removeTag": _vm.removeTag,
      "addTag": _vm.addTag
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.campaigns) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h3', [_vm._v("Clone from existing campaign")]), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "select",
      "option-groups": _vm.campaigns
    },
    model: {
      value: (_vm.campaignToClone),
      callback: function($$v) {
        _vm.campaignToClone = $$v
      },
      expression: "campaignToClone"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "button",
      "label": "Clone",
      "disabled": !_vm.campaignToClone
    },
    on: {
      "click": function($event) {
        return _vm.cloneCampaign()
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h3', [_vm._v("Fields")]), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "group"
    }
  }, [(_vm.campaignModel.fields.length) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Field")]), _vm._v(" "), _c('th', [_vm._v("API Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Default Value")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.campaignModel.fields), function(f, ix) {
    return [_c('tr', {
      key: ((f.field ? f.field.id : 'empty') + "-" + ix + "-data")
    }, [_c('td', {
      staticClass: "sort-buttons"
    }, [_c('button', {
      staticClass: "btn btn-sm",
      attrs: {
        "disabled": ix == 0
      },
      on: {
        "click": function($event) {
          return _vm.moveFieldUp(ix)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm",
      attrs: {
        "disabled": ix == (_vm.campaignModel.fields.length - 1)
      },
      on: {
        "click": function($event) {
          return _vm.moveFieldDown(ix)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })])]), _vm._v(" "), _c('th', {
      staticClass: "align-middle"
    }, [(_vm.campaignModel.campaign_type == 'facebook') ? _c('FormulateInput', {
      attrs: {
        "type": "select",
        "options": _vm.availableFields
      },
      model: {
        value: (f.field),
        callback: function($$v) {
          _vm.$set(f, "field", $$v)
        },
        expression: "f.field"
      }
    }) : _c('span', [_vm._v(_vm._s(f.field ? _vm.fieldOptions[f.field].name : "-"))])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('FormulateInput', {
      attrs: {
        "type": "text",
        "disabled": _vm.campaignModel.campaign_type == 'facebook'
      },
      model: {
        value: (f.alias),
        callback: function($$v) {
          _vm.$set(f, "alias", $$v)
        },
        expression: "f.alias"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(!f.field) ? _c('span', [_c('i', [_vm._v("Please select a field")])]) : _c('FormulateInput', {
      attrs: {
        "type": "select",
        "options": _vm.fieldOptions[f.field].campaign_field_type_options
      },
      model: {
        value: (f.field_type),
        callback: function($$v) {
          _vm.$set(f, "field_type", $$v)
        },
        expression: "f.field_type"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('FormulateInput', {
      attrs: {
        "type": "text"
      },
      model: {
        value: (f.default_value),
        callback: function($$v) {
          _vm.$set(f, "default_value", $$v)
        },
        expression: "f.default_value"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('FormulateInput', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleFieldNotes(ix)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('FormulateInput', {
      attrs: {
        "label": "-",
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeField(ix)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1)]), _vm._v(" "), (f.showNotes) ? _c('tr', {
      key: ((f.field ? f.field.id : 'empty') + "-" + ix + "-notes"),
      staticClass: "field-notes-row"
    }, [_c('td', {
      attrs: {
        "colspan": "7"
      }
    }, [_c('FormulateInput', {
      attrs: {
        "type": "textarea",
        "label": "Notes"
      },
      model: {
        value: (f.notes),
        callback: function($$v) {
          _vm.$set(f, "notes", $$v)
        },
        expression: "f.notes"
      }
    })], 1)]) : _vm._e()]
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v("Add field")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Field")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('FormulateInput', {
    attrs: {
      "type": "select",
      "options": _vm.availableFields,
      "placeholder": "Pick a field"
    },
    on: {
      "input": _vm.addFieldChange
    },
    model: {
      value: (_vm.field),
      callback: function($$v) {
        _vm.field = $$v
      },
      expression: "field"
    }
  })], 1), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "type": "select",
      "disabled": !_vm.field,
      "options": _vm.addFieldTypeOptions,
      "placeholder": "Pick a type"
    },
    model: {
      value: (_vm.field_type),
      callback: function($$v) {
        _vm.field_type = $$v
      },
      expression: "field_type"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('FormulateInput', {
    attrs: {
      "type": "button",
      "label": "+ Add",
      "disabled": !_vm.field || !_vm.field_type
    },
    on: {
      "click": function($event) {
        return _vm.addField()
      }
    }
  })], 1)])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_vm._v("Billing Condition")]), _vm._v(" "), _c('boolean-expression-widget', {
    attrs: {
      "expression": _vm.campaignModel.billing_condition
    },
    on: {
      "updateExpression": _vm.updateBillingCondition
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', [_vm._v("Capacity Limits")]), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "group"
    }
  }, [_c('table', {
    staticClass: "table table-borderless"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Hourly")]), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: (_vm.campaignModel.capacity.hourly),
      callback: function($$v) {
        _vm.$set(_vm.campaignModel.capacity, "hourly", $$v)
      },
      expression: "campaignModel.capacity.hourly"
    }
  })], 1), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "label": "-",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.campaignModel.capacity.hourly = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Daily")]), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: (_vm.campaignModel.capacity.daily),
      callback: function($$v) {
        _vm.$set(_vm.campaignModel.capacity, "daily", $$v)
      },
      expression: "campaignModel.capacity.daily"
    }
  })], 1), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "label": "-",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.campaignModel.capacity.daily = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Weekly")]), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: (_vm.campaignModel.capacity.weekly),
      callback: function($$v) {
        _vm.$set(_vm.campaignModel.capacity, "weekly", $$v)
      },
      expression: "campaignModel.capacity.weekly"
    }
  })], 1), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "label": "-",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.campaignModel.capacity.weekly = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Monthly")]), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "type": "number",
      "min": "1"
    },
    model: {
      value: (_vm.campaignModel.capacity.monthly),
      callback: function($$v) {
        _vm.$set(_vm.campaignModel.capacity, "monthly", $$v)
      },
      expression: "campaignModel.capacity.monthly"
    }
  })], 1), _vm._v(" "), _c('td', [_c('FormulateInput', {
    attrs: {
      "label": "-",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.campaignModel.capacity.monthly = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1)])])])])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d85a842"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CampaignModal.vue
// module id = 667
// module chunks = 0